module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-05.6a076934.png";